import React from "react";
import RatingBar from "./RatingBar";
import "./Programming.css";
export default function Programming() {
  return (
    <div className="programming-card">
      <div className="col">
        <RatingBar label={"C++"} score={"80%"} />
        <RatingBar label={"Node JS"} score={"75%"} />
        <RatingBar label={"Express Js"} score={"75%"} />
        <RatingBar label={"React Js"} score={"60%"} />
        <RatingBar label={"Mongo DB"} score={"75%"} />
      </div>
      <div className="col">
        <RatingBar label={"MySql"} score={"65%"} />
        <RatingBar label={"OOPs"} score={"80%"} />
        <RatingBar label={"Java"} score={"70%"} />
        <RatingBar label={"Html,Css"} score={"70%"} />
      </div>
    </div>
  );
}
